module.exports = __webpack_public_path__ + "static/media/sub_ourservices_researchmantoring.af91b4cb.jpg";